<script lang="ts">
  import type { FieldState } from '@shared/types';
  import { cn } from '@shared/utils';

  import Label from './label.svelte';

  export let state: FieldState = 'default';
  export let helperText: string | undefined = undefined;
  export let label: string | undefined = undefined;
  export let noMargin = false;
  export let noBorder = false;
  export let containerClass = '';
</script>

<div>
  <Label {label} {state} />
  <div
    class="{cn(
      'text-content relative w-full items-center rounded-lg bg-opacity-50 transition-colors dark:bg-opacity-20',
      {
        'mb-6': !noMargin,
        border: !noBorder,
        'text-default-900 dark:bg-dark-300 dark:text-dark-900 border-teal-600 bg-white/50': state === 'success',
        'border-default-500 text-default-900 dark:border-dark-800 dark:bg-dark-300 bg-white/50 dark:text-white':
          state === 'active',
        'pointer-none border-default-200 bg-default-100 text-default-400 dark:border-dark-200 dark:bg-dark-200 dark:text-dark-500':
          state === 'disabled',
        'border-default-300 text-default-900 hover:border-default-400 hover:text-default-900 dark:border-dark-400 dark:bg-dark-300 hover:dark:border-dark-500 hover:dark:text-default-50 bg-white/50 transition-colors dark:text-white':
          state === 'default',
        'border-red-650 text-default-900 dark:bg-dark-300 dark:text-dark-900 bg-white/50': state === 'error',
      },
      containerClass,
      {
        'border-red-650': state === 'error',
      },
    )}"
  >
    <slot />

    {#if helperText}
      <p
        class="{cn('absolute left-0 top-full text-sm', {
          'text-red-650': state === 'error',
          'text-teal-600': state === 'success',
          'text-default-600 dark:text-dark-600': state === 'default',
        })}"
      >
        {helperText}
      </p>
    {/if}
  </div>
</div>
